import { Model } from 'app/model/backendmodel';
import { SapBwCopySource } from './../../../pipeline/copysource/sap-bw.copysource';
import { AdapterRegistry } from '../../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { ValueAdapter } from '../../value.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapBwCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*'
    }
})
export class SapBwCopySourceAdapter extends CopySourceAdapter<SapBwCopySource, Model.SapBwSource> {
    protected override async _toResource(copySource: SapBwCopySource): Promise<Model.SapBwSource> {
        const result: Model.SapBwSource = this.getCommonCopySourceProperties(
            copySource,
            Metamodel.modelFor(SapBwCopySource).name
        );
        if (copySource.mode === 'query') {
            result.query = ValueAdapter.toResource(copySource, SapBwCopySource.READER_QUERY);
        }
        return result;
    }

    protected override async _toModel(
        resource: Model.SapBwSource,
        copyActivity: CopyActivity
    ): Promise<SapBwCopySource> {
        return this._toTabularModel(resource, copyActivity, SapBwCopySource.MODEL);
    }
}
